var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 154.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f5ff;}.cls-2{fill:#d2daff;}.cls-3{fill:#a425b0;}.cls-4{fill:#9e19ab;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171.96,
    width: 903.04,
    height: 154.64
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 352.91,
    y: 41.52,
    width: 169.92,
    height: 27.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 352.91,
    y: 88.19,
    width: 400.08,
    height: 27.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.62,
    y: 28.37,
    width: 15.27,
    height: 87.61
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.62,
    y: 28.37,
    width: 15.27,
    height: 87.61,
    transform: "translate(123.44 20.92) rotate(90)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 268.69,
    cy: 79.07,
    r: 55.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M965.08,62.42l9.58-5.64V48.47c0-.44.06-2.86-1.6-4l-21.92-13a4.48,4.48,0,0,0-1.41-.54,10.23,10.23,0,0,0-4,.08,4.26,4.26,0,0,0-1.24.48l-20.8,12s-3.2,1.6-3.2,4.88V73.7a4.51,4.51,0,0,0,2.29,3.66l22.11,12.89a5.67,5.67,0,0,0,5.57,0L988,68.46a4.17,4.17,0,0,1,1-.43c1.15-.33,3.7-.85,5.43.18l11.53,6.46a4.33,4.33,0,0,1,1.27,1.06,5.25,5.25,0,0,1,1.3,3.31V92.88c0,.14,0,.28,0,.43a3.66,3.66,0,0,1-1.8,3.25l-.27.17-12.15,7.33a4.28,4.28,0,0,1-1.84.62,9.27,9.27,0,0,1-3.63-.47,4.3,4.3,0,0,1-.82-.37L977.26,97.7a4.88,4.88,0,0,1-.66-.46A7.77,7.77,0,0,1,974,91.92a48,48,0,0,1,.16-7.93l-9,5.42v9.43a4.45,4.45,0,0,0,1.2,3,9.67,9.67,0,0,0,1.37,1.17c2.3,1.68,17.92,10.62,20.58,12.14a4.61,4.61,0,0,0,1,.42,9.06,9.06,0,0,0,5.18,0,5.17,5.17,0,0,0,.75-.36l20.6-12a6.85,6.85,0,0,0,2.87-3.52,4.45,4.45,0,0,0,.18-1.25l.06-25.64a3,3,0,0,0,0-.67c-.08-.47,0-1.9-3.13-3.37-.13-.06-.25-.13-.37-.2L994.48,56.39s-3.3-2.15-7.59.79a1.64,1.64,0,0,1-.22.14L951,78.72a4.47,4.47,0,0,1-.83.39,7.7,7.7,0,0,1-4.68.13,4.39,4.39,0,0,1-1-.46l-11.9-7.43a4.31,4.31,0,0,1-1.69-1.92,7.58,7.58,0,0,1-.63-3.05c0-2.25.1-10,.14-12.71a4.4,4.4,0,0,1,.67-2.29,7,7,0,0,1,2.69-2.53l10.6-6.1s3.74-2,6.86,0l11.14,6.63A6.06,6.06,0,0,1,965.07,54c0,.12,0,.24,0,.36Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.112557c35fb21b737e2cfe57ae44e2cc.svg";
export { ForwardRef as ReactComponent };